<template>
	<div id="botionfo">
		<div class="dibu">
			<ul>
					<li>
							<img src="~assets/images/dibu.jpg" alt="">
							<p>专业</p>
					</li>
					<li>
							<img src="~assets/images/dibu.jpg" alt="">
							<p>简便</p>
					</li>
					<li>
							<img src="~assets/images/dibu.jpg" alt="">
							<p>下载速度快</p>
					</li>
			</ul>
		</div>
		<div class="jp">
		    <img src="~assets/images/gj.gif" alt="">
		</div>
		<!-- 版权 -->
		<div class="banq">
		    <div class="banq1">
		        <div class="banq2">
		            <p style="color: rgb(141, 141, 141); font-size: 15px;">本站内容来源于互联网搬运，仅限用于小范围内传播学习，请在下载后24小时内删除。 <br><br> 如果有侵权内容、不妥之处，请第一时间联系我们删除。敬请谅解! <br><br>我们的联系方式&nbsp;&nbsp;&nbsp;E-mail：368783093@qq.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QQ：368783093
		                <br><br> 下载国度 - <a href="#">侵权处理</a> - <a href="#">版权声明</a> - 网站地图 
		                <br><br> 2022 下载国度-下载网-IT宝箱网</p>
		        </div>
		        <div class="banq3">
		            <span>如果你也喜欢本站请分享给朋友吧</span>
		            <div style="height: 5px;"></div>
		            <div>
		                <img src="~assets/images/banq2jpg.png" alt="">
		            </div>
		            <div class="bshare-custom"><a title="分享到QQ好友" class="bshare-qqim"></a><a title="分享到微信" class="bshare-weixin"></a><a title="分享到新浪微博" class="bshare-sinaminiblog"></a><a title="分享到QQ空间" class="bshare-qzone"></a><a title="分享到Gmail" class="bshare-gmail"></a><a title="分享到人人网" class="bshare-renren"></a><a title="更多平台" class="bshare-more bshare-more-icon more-style-addthis"></a><span class="BSHARE_COUNT bshare-share-count">0</span></div>
		        </div>
		    </div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'botionfo',
		data(){
			return{
				
			}
		},
		methods:{
		}
	}
</script>

<style scoped>
	.dibu{
	    height:300px;
	    /* border: solid 2px #000000; */
	    margin-top: 8px;
	}
	.dibu ul li{
	    float: left;
	    width: 393.3px;
	    /* border: solid 2px #3287f6; */
	    text-align: center;
	    height: 300px;
			
	    line-height: 300px;
	    overflow: hidden;
	}
	.dibu ul li img{
	    width: 393.3px;
			position: relative;
	    height: 300px;
	    transition:all 0.8s;
	}
	.dibu ul li p{
	    width: 393.3px;
	    height: 300px;
	    background-color: rgba(0,0,0,0.2);
	    position: absolute;
	    top:1065px;
	    z-index: 999;
	    font-size: 25px;
	    color: rgb(245, 65, 164);
	    font-weight: bold;
	}
	.dibu ul li:hover p{
	    background: none;
	}
	.dibu ul li:hover img{
	    transform: scale(1.2);
	}
	.jp{
	    margin-top:20px;

	}
	.jp img{
	    width: 100%;
	}

	/* 版权 */
	.banq{
	    width: 100%;
	    height: 240px;
	    background: #2b2a2a;
	    position: absolute;
	    top:1480px;
	    right:0px;
	}
	.banq1{
	    width: 1200px;
	    /* border: solid 2px #3287f6; */
	    height: 220px;
	    margin: 0 auto;
	}
	.banq2{
	    width: 900px;
	    /* border: solid 2px #f1740d; */
	    height: 180px;
	    margin-top: 20px;
	    float: left;
	}
	.banq2 a{
	    color:rgb(141, 141, 141); text-decoration: none;
	}
	.banq2 a:link{
	    color:rgb(141, 141, 141);
	}
	.banq2 a:hover{
	    color: rgb(250, 0, 0);
	}
	.banq3{
	    float: right;
	    width: 290px;
	    /* border: solid 2px #3287f6; */
	    margin-top: 18px;
	    height: 180px;
	    text-align: center;
	}
	.banq3 span{
	    color: rgb(141, 141, 141);
	    font-size: 15px;
	}

</style>